import Head from 'next/head';
import { useContext, useState, useEffect, useReducer } from 'react';
import Link from 'next/link';
import styles from "../../styles/Pages/Packages.module.scss";
import Topbanner from '../../components/Reusable/Banner/Topbanner';
import { HiOutlineMinusCircle, HiOutlinePlusCircle } from 'react-icons/hi';
import { CartContext } from '../../context/CartContext';
import Cart from './cart';
import Image from 'next/image';
import Pixel from '../../components/Pixel';
import { decryptData, encryptData } from '../../utils/encrypting';

const Packages = () => {
    const { popUp, setPopUp, cart, bands, setCart, addToCart, handleAddToCart, handleBookNow, handleIncrementQuantity, updateCartItemQuantity, handleDecrementQuantity } = useContext(CartContext);

    let discount = 10;

    return (
        <>
            <Head>
                <title>Amusement Park Packages | Deals and Offers-Adventure Resorts</title>
                <meta name="description" content="We provide a variety of packages for kids as well as adventure packages and personalized activities for adults.- Adventure Resorts" />
                <link rel="icon" href="/favicon.png" />
                <link rel="canonical" href="https://www.adventureresortkufri.com/tickets" />

            </Head>
            <Pixel name={"ViewTicketsContent"} />

            <section className='tickets_page_banner'
                style={{ backgroundImage: 'url(/images/banners/tickets-banner.jpg)' }}
                target="#firstsec"
            >
                <div className='tickets_page_banner_text'>
                    <div className='container common_title'>
                        <h1>Our Tickets</h1>
                    </div>
                </div>
            </section>

            <section className={`${styles.allpackages} common_padding pb-0`} id="firstsec">
                <div className='container'>
                    {popUp ?
                        <div className={styles.quantity_popup}>
                            <div className={styles.popup_alert}>
                                <Image src="/icons/ok-gif.gif" width={64} height={64} alt="Packages Added to Cart" />
                                <h5 className='mt-2 mb-3'>Package Added to Cart</h5>
                                <button style={{ border: 'none' }} className='secoundary_btn' onClick={() => setPopUp(false)}>Ok</button>
                            </div>
                        </div>
                        : null}
                    <div className='row'>
                        {bands && bands.length > 0 ?
                            <>
                                {bands?.sort((a, b) => parseFloat(a.price) - parseFloat(b.price)).map((band) => (
                                    <div className="col-md-4" key={band.id}>
                                        <div className={`${styles.package_child} common_title text-center`} style={{ backgroundColor: 'white' }}>

                                            {band.discounted_price ? (
                                                <div className={styles.package_ribbon}><span>{band.discount_applied} % Off</span></div>
                                            ) : ''}

                                            <h3 style={{ color: 'black' }}>{band.name}</h3>
                                            <div className={styles.package_child_detail}>
                                                <div className={styles.details}>
                                                    <h4 className={styles.price}>
                                                        <span className={styles.regular_price}>₹ {band.price}</span>
                                                        {/* {band.discounted_price ? ( */}
                                                        <span className={styles.offered_price}>₹ {band.discounted_price}</span>
                                                        {/* ) : ''} */}
                                                    </h4>
                                                    <h4>Rides & Activities</h4>
                                                    <p>{band.description}</p>
                                                </div>

                                                <div>
                                                    <div className='d-flex justify-content-center my-2'>
                                                        <p className='m-0'>Qty : </p>
                                                        <div className='d-flex ms-2'>
                                                            <button className={styles.qnatity_btn} onClick={() => handleDecrementQuantity(band.id)}><HiOutlineMinusCircle /></button>
                                                            {/* <p className={styles.quantity_items}><strong>{band.quantity}</strong></p> */}
                                                            <p className={styles.quantity_items}><strong>{band.quantity}</strong></p>
                                                            <button className={styles.qnatity_btn} onClick={() => handleIncrementQuantity(band.id)}><HiOutlinePlusCircle /></button>
                                                        </div>
                                                    </div>
                                                    {/* {band.quantity===0 ? <button
                                                onClick={() => setPopUp(true)}
                                                className='common_btn m-2'
                                                >Add to Cart</button> : <button
                                                onClick={() => handleAddToCart(band, band.quantity)}
                                                className='common_btn m-2'
                                                >Add to Cart</button>
                                            } */}
                                                    <div className={styles.common_btn_parent}>
                                                        <button
                                                            onClick={() => handleAddToCart(band, band.quantity)}
                                                            className='common_btn m-2'
                                                        >Add to Cart
                                                        </button>

                                                        <button
                                                            onClick={() => handleBookNow(band, band.quantity)} // Use the new function
                                                            className="secoundary_btn m-2"
                                                            style={{ border: `none` }}>
                                                            BUY NOW
                                                        </button>
                                                    </div>

                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                ))}
                            </>
                            :
                            <div className='text-center'>
                                <h5 className='mb-3'>No Tickets Found! Please Try Again Later</h5>
                                <Link href='/' className='common_btn mb-4'>Back To Home</Link>
                            </div>
                        }
                    </div>
                </div>
            </section>
        </>
    )
}
export default Packages;